import React from "react";
import { Navigate, Outlet } from "react-router-dom";

import { routes } from "./routes";
import { useAuth } from "../components/auth/AuthenticationContext";

export const SignedInRoute: React.FC = () => {
  const auth = useAuth();

  if (auth.state !== "SIGNED_IN") {
    return (
      <Navigate to={routes.login} state={{ route: window.location.pathname }} />
    );
  }

  return <Outlet />;
};
